(() => {
  if (globalThis.GiestoColorGroups) return;

  const normalize = value => String(value || '').normalize('NFKD')
    .replace(/\p{M}/gu, '').toLowerCase().replace(/ı/g, 'i')
    .replace(/[^a-z0-9]+/g, ' ').trim();
  const identity = product => String(product.id || '').replace('gid://shopify/Product/', '');
  const model = (title, color) => {
    const name = ` ${normalize(title)} `;
    const normalizedColor = normalize(color);
    const candidates = normalizedColor === 'kahve' ? ['kahverengi', 'kahve'] : [normalizedColor];
    const shade = candidates.filter(Boolean).map(value => ` ${value} `).find(value => name.includes(value));
    if (!shade) return null;
    return name.replace(shade, ' ').trim().replace(/ +/g, ' ');
  };

  function match(container, group) {
    // A product that carries several colours as its own variants is already
    // its own colour group. Title matching would attach unrelated products to
    // it, so callers flag it and it gets no app group at all.
    if (container?.dataset?.multiColour === 'true') return { ...group, products: [] };
    const products = group?.products || [];
    const current = products.find(product => identity(product) === container.dataset.p);
    if (!current) return { ...group, products: [] };
    // Compare records from the same canonical catalog. Storefront titles and
    // option values are translated, while the app's group records may not be.
    const family = model(current.title, current.color);
    const matches = products.filter(product => identity(product) === container.dataset.p ||
      (family && model(product.title, product.color) === family));
    return {
      ...group,
      products: matches.map(product => ({
        ...product,
        // Keep Turkish combining characters intact, encoded once in the path.
        handle: encodeURIComponent(decodeURIComponent(product.handle || '')),
        color: container.dataset.locale === 'en' ? englishColors[normalize(product.color)] || product.color : product.color,
      })),
    };
  }

  const englishColors = {
    beyaz: 'White', siyah: 'Black', lacivert: 'Navy', mavi: 'Blue', 'acik mavi': 'Light blue',
    kahve: 'Brown', bej: 'Beige', haki: 'Khaki', sari: 'Yellow', kahverengi: 'Brown', yesil: 'Green',
    'petrol yesil': 'Petrol green', turuncu: 'Orange', bordo: 'Burgundy', kirmizi: 'Red',
    mint: 'Mint', pembe: 'Pink', ekru: 'Ecru', gri: 'Grey', antrasit: 'Anthracite',
    taba: 'Tan', indigo: 'Indigo', mor: 'Purple', krem: 'Cream', tas: 'Stone',
    gumus: 'Silver', altin: 'Gold', 'acik gri': 'Light grey', 'koyu gri': 'Dark grey',
    'koyu mavi': 'Dark blue', 'acik yesil': 'Light green', 'koyu yesil': 'Dark green',
  };
  function localizeLinks(container) {
    const root = (container.dataset.root || '/').replace(/\/$/, '');
    for (const anchor of container.querySelectorAll('a[href^="/products/"]')) {
      anchor.setAttribute('href', root + anchor.getAttribute('href'));
    }
  }
  globalThis.GiestoColorGroups = { match, model, localizeLinks };
})();
